import { Button, Col, DatePicker, Flex, Form, Input, InputNumber, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useContext, useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../utils/eventEmitter';
import usePosSalesUpdateAPI from '../apis/posSalesUpdateAPI';
import AuthContext from '../../utils/AuthContext';
import dayjs from 'dayjs';
import Axios from '../utils/axios';
import StatusComponent from '../../globalComponents/StatusComponent';




const PosSalesUpdateChanges = () => {
  const { salesUpdate } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { create, update } = usePosSalesUpdateAPI();
  const [pos, setPos] = useState([]);
  const [employees, setEmployees] = useState([]);

  salesUpdate.date = salesUpdate.date ? dayjs(salesUpdate.date, 'YYYY-MM-DD') : '';

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data.user_id = user.id
    create(data, success);
    // console.log(data);
  };

  const submit = () => { 
    let data = form.getFieldsValue();
    data['id'] = salesUpdate.id;
    data.status = 'submitted';
    update(salesUpdate.seo.replaceAll('/', '-'), data, success);
    // console.log(data)
  };

  const reSubmit = () => { 
    let data = form.getFieldsValue();
    data['id'] = salesUpdate.id;
    data.status = 'submitted';
    update(salesUpdate.seo.replaceAll('/', '-'), data, success);
    // console.log(data)
  };

  const approved = () => { 
    let data = form.getFieldsValue();
    data['id'] = salesUpdate.id;
    data.status = 'approved';
    update(salesUpdate.seo, data, success);
    // console.log(data)
  };


  
  useEffect(() => {
    EventEmitter.subscribe('sales_update_response', data => {
      navigate('/pos/sales-update/'+data.replaceAll('/', '-'));
    });

    return () => {
      EventEmitter.unsubscribe('sales_update_response');
    }
  },[])

 
  useEffect(() => {
    Axios.get('setups/pos-sales-update/'+user.access_right.default_warehouse)
    .then(res => {
      setPos(res.data.pos);
      setEmployees(res.data.employees)
    })
    .catch(err => console.log(err))
  },[])

  
  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/pos/sales-update'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Sales Update</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ salesUpdate.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {/* {salesUpdate.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>} */}
      </div>
      <div className='flex justify-between bg-white'>
        <Flex wrap='wrap' align='center' gap={'small'} style={{ maxWidth: '70%' }}>
          {salesUpdate.status === 'to_submit' &&
            <>
              <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={submit}>SUBMIT</Button>
            </>
          }
          {salesUpdate.status === 'submitted' && <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={reSubmit}>RESUBMIT</Button>}
        </Flex>
        <StatusComponent formValue={salesUpdate} name={'SALES_UPDATE'} />
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 8 }}
          labelWrap={true}
          initialValues={salesUpdate.seo ? salesUpdate : {
            cash_in_hand: 0.00,
            sales: 0.00,
            momo: 0.00,
            bank: 0.00,
            delivery_fee: 0.00,
            date: dayjs(new Date())
          }}
          disabled={
            (salesUpdate.status === 'submitted' && user.access_right.pos_config_accountant === 1) ? true :
            (salesUpdate.status === 'submitted' && user.access_right.pos_config_cashier === 1) ? false :
            !salesUpdate.status && false
          }
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Point of Sale' name='point_of_sale_id' className='font-semibold text-gray-800 mb-1' required >
                <Select options={pos.map(item => ({value: item.id, label: item.name}))} style={{width: '200px'}}/>
              </Form.Item>
              <Form.Item label='Responsible' name='employee_id' className='font-semibold text-gray-800 mb-1' required >
                <Select options={employees.map(item => ({value: item.id, label: item.name}))} style={{width: '200px'}}/>
              </Form.Item>
              <Form.Item label='User' className='font-semibold text-gray-800 mb-1' required >
                <Input type='text' value={user.user} readOnly className='font-normal input-outline-none'/>
              </Form.Item>
              <Form.Item label='Sales' name={'sales'} className='font-semibold text-gray-800 mb-1' required >
                <InputNumber readOnly className='font-normal'/>
              </Form.Item>
              <Form.Item label='Momo' name='momo' className='font-semibold text-gray-800 mb-1' required >
                <InputNumber className='font-normal'/>
              </Form.Item>
            </Col>
            <Col md={{span: 11}}>
              <Form.Item label='Date' name='date' className='font-semibold text-gray-800 mb-1' required>
                <DatePicker inputReadOnly readOnly disabled/>
              </Form.Item>
              <Form.Item label='Expenses' name='expenses' className='font-semibold text-gray-800 mb-1' required >
                <InputNumber className='font-normal'/>
              </Form.Item>
              <Form.Item label='Bank Transfer' name='bank' className='font-semibold text-gray-800 mb-1' required >
                <InputNumber className='font-normal'/>
              </Form.Item>
              <Form.Item label='Cash In Hand' name='cash_in_hand' className='font-semibold text-gray-800 mb-1' required >
                <InputNumber className='font-normal'/>
              </Form.Item>
              <Form.Item label='Delivery Fee' name='delivery_fee' className='font-semibold text-gray-800 mb-1' required >
                <InputNumber className='font-normal'/>
              </Form.Item>
            </Col>
          </Row>

          <Tabs 
            className='mt-3'
            type='card'
            items={[
              {
                key: 1,
                label: 'Note',
                children: 
                  <Form.Item name='note' className='font-semibold text-gray-800 mb-1'>
                    <Input type='text' placeholder='Add any additional notes' className='font-normal input-outline-none'/>
                  </Form.Item>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default PosSalesUpdateChanges;